import * as React from 'react';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { ToneRowOptionsPrivilage, ToneRowOptionsPrivilageImpl } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { ToneCardCSSStyle, ToneCardCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { SearchListToneCardPlayerCSSStyleImpl } from '../../searchlist/searchlisttonecardplayercss';
import { ToneEvenCardCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/toneevencardcssstyle';
import { ListViewModelImpl } from '../../../../toolkit/horizontallist/listviewmodel';
import { WishlistToneCardComponent } from './wishlisttonecardcomponent';
import { ToneMobileCardPlayerCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonemobilecardplayercss';
import { ToneCardPlayerCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardplayercss';

export class WishlistToneRowOptionsPrivilageImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setTellAFriend(true);
        this.setDelete(true);
        this.setGift(true);
        this.setShare(true);
        this.setBuy(true);
        this.setLike(true);
        this.setPlay(true);
    }
}

export class WishlistToneViewModelImpl extends ListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private audioPlayerWithProgress: AudioPlayerWithProgress;
    private toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
    private playerCSSStyle: SearchListToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;

    constructor(context: BaseContext, private marginTop: string, private onDelete: any)
    {
        super(context);

        this.toneOddCardCSSStyle = new ToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ToneEvenCardCSSStyleImpl(context);
        this.toneRowOptionsPrivilage = new WishlistToneRowOptionsPrivilageImpl();
        this.playerCSSStyle = new SearchListToneCardPlayerCSSStyleImpl(context);
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <WishlistToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={this.onDelete} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={() =>{}} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <WishlistToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={this.onDelete} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={() =>{}} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/tones/wishlisttoneviewmodel.tsx